import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
const Home = React.lazy(() => import('./pages/Home'));
const Explore = React.lazy(() => import('./pages/Explore'));

function App() {
  return (<>
    <Router>
      <Suspense fallback={<></>}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/explore/:id" exact component={Explore} />
        </Switch>
      </Suspense>
    </Router>
  </>);
}

export default App;
